import T from '../../../../../../common/components/T';

export const skeletonElements = () => {
    return [
        {
            type: 'circle',
            align: 'right'
        },
        {
            type: 'title',
            width: 60,
            align: 'center'
        },
        {
            type: 'table',
            size: {
                columns: 3,
                rows: 6
            }
        }
    ];
};

export const gridThead = {
    data: [
        {
            type: 'login',
            title: <T textName='pageOffice-gridThead-1-new' defaultStr='ФИО, ID' page='/office' />,
            name: 'user'
        },
        {
            type: 'check',
            name: 'from_structure',
            title: <T textName='from_lp_structure' defaultStr='Из структуры ЛП' page='/office' />
        },
        {
            type: 'text',
            title: <T textName='branch-details-modal-thead-2' defaultStr='Баллов, PV' page='/office' />,
            name: 'scores',
            align: 'left'
        },
        {
            type: 'login',
            title: <T textName='branch-details-modal-thead-3' defaultStr='ФИО, ID спонсора' page='/office' />,
            name: 'sponsor',
            align: 'left'
        },
        {
            type: 'text',
            title: <T textName='branch-details-modal-thead-5' defaultStr='Неделя' page='/office' />,
            name: 'week',
            align: 'left'
        }
    ]
};

export const transformGridData = (data) => {
    return {
        ...data,
        data: data?.data?.map((item) => ({
            user: {
                ...item?.user,
                full_name: item?.user?.name
            },
            from_structure: item?.is_self_structure,
            scores: item?.value || '-',
            sponsor: item?.sponsor,
            week: item?.marketing_period_id || '-'
        }))
    };
};
